<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse navText="Usuarios" :to="{ name: 'Usuarios' }">
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="Tipo de Multimedia" :to="{ name: 'TipoMultimedia' }">
          <template #icon>
            <CreditCard />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="Cursos" :to="{ name: 'Categorias' }">
          <template #icon>
            <Curso />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="Biblioteca" :to="{ name: 'Categorias' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="Comunicación" :to="{ name: 'Categorias' }">
          <template #icon>
            <Comunicaciones />
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>
<script>
import SidenavCollapse from './SidenavCollapse.vue'
import Shop from '../../components/Icon/Shop.vue'
import Curso from '../../components/Icon/Box3d.vue'
import Office from '../../components/Icon/Document.vue'
import CreditCard from '../../components/Icon/CreditCard.vue'
import Comunicaciones from '../../components/Icon/Air.vue'
// import Box3d from '../../components/Icon/Box3d.vue'
// import CustomerSupport from '../../components/Icon/CustomerSupport.vue'
// import Document from '../../components/Icon/Document.vue'
// import Spaceship from '../../components/Icon/Spaceship.vue'
// import Settings from '../../components/Icon/Settings.vue'

export default {
  name: 'SidenavList',
  props: {
    cardBg: String
  },
  data () {
    return {
      title: 'Soft UI Dashboard PRO',
      controls: 'dashboardsExamples',
      isActive: 'active'
    }
  },
  components: {
    SidenavCollapse,
    Curso,
    Shop,
    Office,
    CreditCard,
    Comunicaciones
    // Box3d,
    // CustomerSupport,
    // Document,
    // Spaceship,
    // Settings
  },
  methods: {
    getRoute () {
      const routeArr = this.$route.path.split('/')
      return routeArr[1]
    }
  }
}
</script>
